(function() {
  'use strict';

  angular
    .module('index', [])
    .controller('IndexCtrl', IndexCtrl);

  /** @ngInject */
  function IndexCtrl($state, UserCache) {
    var vm = this;

    var cache = UserCache.getObject();
    if (cache !== undefined && cache !== null) {
      enter(cache);
    } else {
      $state.go('signin');
    }

    function enter(data){
      var user = data.user;
      var permission = localStorage.getItem('permission');
      if(user.producer === undefined && user.admin === undefined){
         swal("You do not have permission!", "", "error");
         $state.go('signin');
      } else if (user.producer !== undefined && user.admin === undefined){
        $state.go('pub.channels');
      } else if (user.producer === undefined && user.admin !== undefined){
        $state.go('admin.home');
      } else if (user.producer !== undefined && user.admin !== undefined){
        if (permission !== null) {
          if (permission === 'admin') {
            $state.go('admin.home');
          } else {
            $state.go('pub.channels');
          }
        } else {
          $state.go('admin.home');
        }
      }
    }
  }

})();
